// extracted by mini-css-extract-plugin
module.exports = {"container":"_3JG6peVqgqSC4WLKkhvAoQ","tags-container":"_3vWmnoCEMiz4ja_Lx3Q8n4"};